import { motion } from "framer-motion";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import diversityHero from "@/assets/diversity-hero.jpg";

const DiversityPage = () => {
  return (
    <Layout>
      <SEO title="Diversity & Inclusion | Vaughan McLean" description="Vaughan McLean is committed to fostering a diverse and inclusive workplace that reflects the communities and clients we serve." />
      <PageHero backgroundImage={diversityHero} title="Diversity" subtitle="Our Commitment" />

      <section className="section-dark py-24">
        <div className="container mx-auto px-8 lg:px-16">
          <div className="max-w-3xl">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="space-y-8"
            >
              <p className="text-muted-foreground font-body text-lg leading-relaxed">
                Vaughan McLean embraces diversity as a core value to guide us as we grow. We strive to create an environment that supports and promotes meritocracy and acceptance, unhindered by those who would otherwise try to suppress it.
              </p>

              <p className="text-muted-foreground font-body text-lg leading-relaxed">
                Just as we expect excellence in our work and transparency in our dealings, diversity in our members and inclusion in our decision-making provide a powerful foundation for our culture and our day-to-day dealings with each other.
              </p>

              <p className="text-muted-foreground font-body text-lg leading-relaxed">
                We ensure that there is not just a seat at the table, but a meaningful opportunity to be heard because we value the unique perspective each of us contributes.
              </p>

              <p className="text-muted-foreground font-body text-lg leading-relaxed">
                VM hires, trains and promotes lawyers and staff fairly, as is consistent with our goals of equal opportunity and diversity in the practice of law.
              </p>

              <p className="text-foreground font-body text-xl leading-relaxed italic">
                We do not expend energy smashing the glass ceiling – we simply do not have one.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default DiversityPage;
